/** The emails tied to one payment: automated platform confirmations, receipts and
 *  remittance advices sent from here, with who / when / which email and delivery state. */
export type PaymentEmailRow = {
  id: string; kind: string; label: string; automated: boolean; at: string | null; to: string | null; by: string | null;
  subject: string | null; delivery: { state: string; at: string; detail: string | null } | null;
};
const when = (iso: string | null) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
const DELIVERY: Record<string, string> = { delivered: "bg-green-100 text-green-800", opened: "bg-green-100 text-green-800", clicked: "bg-green-100 text-green-800", bounced: "bg-red-100 text-red-700", dropped: "bg-red-100 text-red-700", spam: "bg-red-100 text-red-700", deferred: "bg-amber-100 text-amber-800", sent: "bg-slate-100 text-slate-600" };

export function PaymentEmailLog({ rows, loading }: { rows: PaymentEmailRow[] | undefined; loading?: boolean }) {
  if (loading && !rows) return <p className="mt-3 text-xs text-slate-400">Loading emails…</p>;
  if (!rows?.length) return null;
  return (
    <div className="mt-4 rounded-lg bg-slate-100 p-4">
      <p className="text-sm font-normal">Emails</p>
      <ul className="mt-1 divide-y divide-slate-200">
        {rows.map((r) => (
          <li key={r.id} className="py-2 text-sm">
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
              <span className="font-medium">{r.label}</span>
              {r.automated && <span className="rounded-full bg-slate-200 px-2 py-0.5 text-[10px] font-medium text-slate-700">automated</span>}
              {r.delivery && <span className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${DELIVERY[r.delivery.state] ?? "bg-slate-100 text-slate-600"}`} title={r.delivery.detail ?? undefined}>{r.delivery.state}{r.delivery.at ? ` · ${when(r.delivery.at)}` : ""}</span>}
              <span className="ml-auto text-xs text-slate-500">{when(r.at)}</span>
            </div>
            <p className="text-xs text-slate-600">
              {r.to ? <>to {r.to}</> : <span className="text-slate-400">recipient unknown</span>}
              {r.by ? <> · sent by {r.by}</> : r.automated ? <> · sent by the booking platform when the payment was recorded</> : null}
            </p>
            {r.subject && <p className="text-xs text-slate-500">“{r.subject}”</p>}
          </li>
        ))}
      </ul>
    </div>
  );
}
